export default "__VITE_ASSET__Ee95_Am4__"